/**
 * This selector returns the threadId of the current thread that is being
 * focused within the ThreadView. It is possilbe for this to be null
 * when there is no thread being focused. i.e. an empty view or within search
 * and filtering mode when no thread matches the current filter.
 */
export const getFocusedViewMemberThreadId = state => state.focusedViewMember;